import { useEffect, useState } from "react";
import close from "../img/close.png";
import { encryptPassword } from "../utils/encryption";
import generatePassword from "../utils/generatePassword";
import "../css/Modal.css";
import { addDoc, getDocs, query, where } from "firebase/firestore";
import { passwordsCollection, settingsCollection } from "../utils/firebase";

const Add = ({ setShowAdd, user }) => {
  const [appName, setAppName] = useState("");
  const [username, setUsername] = useState(" ");
  const [password, setPassword] = useState("Enter new password");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [copied, setCopied] = useState(false);
  const [suggestedUsernames, setSuggestedUsernames] = useState([]);
  const [passwordConfig, setPasswordConfig] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    getDocs(query(settingsCollection, where("uid", "==", user.uid))).then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        const { usernames, passwordConfig } = doc.data();
        setSuggestedUsernames(usernames);
        setPasswordConfig(passwordConfig);
        setIsLoading(false);
      });
    });
  }, [user.uid]);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Verify password match
    if (password !== confirmPassword) return setPasswordError("Passwords must match");

    // Start loading
    setIsSubmitLoading(true);

    // Encrypt the plain text password, stores iv used
    const encryptedPassword = encryptPassword(password);

    addDoc(passwordsCollection, {
      appName,
      username,
      encryptedPassword,
      uid: user.uid,
    })
      .then(() => {
        setIsSubmitLoading(false);
        setShowAdd(false);
      })
      .catch((err) => console.log(err));
  };

  const handleNewPassword = () => {
    const generatedPassword = generatePassword(passwordConfig);
    setPassword(generatedPassword);
    setCopied(false);
  };

  const handleCopied = () => {
    navigator.clipboard.writeText(password);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <div className="modal-bg">
      <form className="modal" onSubmit={handleSubmit}>
        <div
          className="modal-close btn"
          onClick={() => {
            setShowAdd(false);
          }}
        >
          <img src={close} alt="Close button" width="50" />
        </div>
        <h1>Add Password</h1>
        <div className="form-control">
          <h4>App name</h4>
          <input
            type="text"
            required
            onChange={(e) => {
              setAppName(e.target.value);
            }}
          />
        </div>
        <div className="form-control">
          <h4>Username</h4>
          <input
            type="text"
            required
            onChange={(e) => {
              setUsername(e.target.value);
            }}
            list="browsers"
          />
          <datalist id="browsers">
            {suggestedUsernames.map((username) => (
              <option value={username} key={username}></option>
            ))}
          </datalist>
        </div>
        <div className="form-control">
          <h4>Password</h4>
          <div className="password-form-item">
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              required
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
            {showPassword && (
              <div className={`copy-password${copied ? " active" : ""}`} onClick={handleCopied}>
                <i className="far fa-copy"></i>
              </div>
            )}
            <div className="new-password" onClick={handleNewPassword}>
              <i className="fas fa-sync"></i>
            </div>
          </div>
        </div>
        <div className="form-control">
          <h4>Confirm password</h4>
          <input
            type={showPassword ? "text" : "password"}
            required
            onChange={(e) => {
              setConfirmPassword(e.target.value);
            }}
          />
          <span className="incorrect-creds">{passwordError}</span>
          <div className="show-password-checkbox">
            <input
              type="checkbox"
              name="showPassword"
              onClick={() => {
                setShowPassword(!showPassword);
                navigator.clipboard.writeText("");
              }}
            />
            <label htmlFor="showPassword">Show Password</label>
          </div>
        </div>
        <button className="form-btn" disabled={isLoading || isSubmitLoading}>
          {isSubmitLoading ? <i className="fas fa-circle-notch fa-spin"></i> : "ADD"}
        </button>
      </form>
    </div>
  );
};

export default Add;
